import FBXLoader from "../loaders/fbx-loader";
import initMaterial from "../utils/init-material";
import QuizManager from "../quizes/quiz-manager";
import getPersistentUrl from "../utils/persistent-path";
import SlideManager from "../utils/slide-manager";
import RenderManager from "../rendering/render-manager";

let fbxLoader, textureLoader;
let textures;

const PATH_ROOT = "ferris_wheel"

const PATH_MODEL = `${PATH_ROOT}/ferris_wheel.fbx`;
const PATH_ALBEDO = `${PATH_ROOT}/ferris_wheel.png`;

class FerrisWheel extends THREE.Object3D {
    constructor() {
        super();

        Q3.ferris = this;

        this.type = "Ferris";
        this._colliders = {};

        textureLoader = textureLoader || new THREE.TextureLoader();
        fbxLoader = fbxLoader || new FBXLoader();
        textures = textures || Object.freeze({
            map: textureLoader.load(getPersistentUrl(PATH_ALBEDO))
        });

        const keysTextures = Object.keys(textures);
        const root = new THREE.Object3D();
        root.dontShowInHierarchyPanel = true;

        fbxLoader.load(getPersistentUrl(PATH_MODEL), (model, other) => {
            const box = new THREE.Box3().setFromObject(model);
            const size = new THREE.Vector3();

            const actions = model.animations.map(clip => Q3.mixer.clipAction(clip, model));
            actions.forEach(action => action.play());

            box.getSize(size);

            const maxSize = 1 / Math.max(size.x, size.y, size.z);

            root.scale.set(maxSize, maxSize, maxSize);

            root.add(model);

            model.traverse(obj => {
                if (!obj.isMesh) return;

                const collider = obj.name.match(/(collision_)([\w\d]+)/);

                if (collider) {

                    obj.colliderType = collider[2];

                    this._colliders[collider] = obj;

                    obj.material.transparent = true;
                    obj.material.opacity = 0;
                } else {
                    keysTextures.forEach(key => obj.material[key] = textures[key]);
                    initMaterial(obj);
                    obj.material.color.setHex(0xffffff);
                }
            });

            RenderManager.activeCamera.update = true;
        });

        this.add(root);
    }

    get selectableParts() { return Object.keys(this._colliders); }

    checkAnswer(raycaster) {
        const slideQuiz = SlideManager.currentSlide.slideQuiz;

        if (slideQuiz.type !== "ferris" || !slideQuiz.active || slideQuiz.userAnswer) return;

        const meshes = this.selectableParts.map(key => this._colliders[key]);
        const intersections = [];

        raycaster.intersectObjects(meshes, false, intersections);

        if (intersections.length === 0) return;

        const selectedAnswer = intersections[0].object.colliderType;
        const correctAnswer = selectedAnswer === (slideQuiz.rightAnswer || "wheel");

        console.log(selectedAnswer, correctAnswer);

        if (correctAnswer) {
            slideQuiz.userAnswer = selectedAnswer;

            slideQuiz.userScore = correctAnswer ? slideQuiz.score : 0;
        }

        QuizManager.submitQuiz();
    }
}

export { FerrisWheel };
export default FerrisWheel;